var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgInvoice = function SvgInvoice(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 3.75C6.92893 3.75 5.25 5.42893 5.25 7.5V19.5C5.25 19.9142 5.58579 20.25 6 20.25H16.5C16.9142 20.25 17.25 19.9142 17.25 19.5V10.5H20.25V6C20.25 4.75736 19.2426 3.75 18 3.75H9ZM15.878 5.25H9C7.75736 5.25 6.75 6.25736 6.75 7.5V18.75H15.75V10.5V9V6C15.75 5.73702 15.7951 5.48458 15.878 5.25ZM17.25 6C17.25 5.58579 17.5858 5.25 18 5.25C18.4142 5.25 18.75 5.58579 18.75 6V9H17.25V6ZM13.5 9.75H9V8.25H13.5V9.75ZM9 12.75H13.5V11.25H9V12.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 3.75C6.92893 3.75 5.25 5.42893 5.25 7.5V19.5C5.25 19.9142 5.58579 20.25 6 20.25H16.5C16.9142 20.25 17.25 19.9142 17.25 19.5V10.5H20.25V6C20.25 4.75736 19.2426 3.75 18 3.75H9ZM15.878 5.25H9C7.75736 5.25 6.75 6.25736 6.75 7.5V18.75H15.75V10.5V9V6C15.75 5.73702 15.7951 5.48458 15.878 5.25ZM17.25 6C17.25 5.58579 17.5858 5.25 18 5.25C18.4142 5.25 18.75 5.58579 18.75 6V9H17.25V6ZM13.5 9.75H9V8.25H13.5V9.75ZM9 12.75H13.5V11.25H9V12.75Z",
    fill: "currentColor",
    fillOpacity: 0.2
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInvoice);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "invoice.e9a5683910b4a012df809d6a4d467ce5.svg";